<template>
    <div class="ui-content dashboard">
        <div ref="centerBox">
            <div class="manage-batches-div">
                <v-btn
                    :color="canDeleteCenter?'primary':'secondary'"
                    class="delete-center"
                    @click="onDeleteCenter()"
                >Delete Center</v-btn>
            </div>
            <div class="center-box center-btn">
                <div class="cent" v-for="center in centers" :key="center.id">
                    <v-text-field
                        class="sub-active"
                        autofocus
                        v-if="center.editable"
                        v-model="center.editableName"
                        @blur="onBlur(center)"
                        @keydown.enter="onBlur(center)"
                        hide-details
                    ></v-text-field>

                    <v-tooltip top v-else content-class="cust-new-tooltip-top">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="onCenterClick(center)"
                                depressed
                                :class="{'text-transform-none':true,'btn-center':true, 'btn-default':true, active:selectedCenter && center.id===selectedCenter.id}"
                            >{{center.name}}</v-btn>
                        </template>
                        <span>{{center.name}}</span>
                    </v-tooltip>
                </div>
            </div>
        </div>
        <v-card class="mx-auto normal-card min-height-80vh-cp3-card">
            <div class="center-details-section" :style="{height: tableHeight}">
                <div class="center-row">
                    <div class="center-col" v-for="batch in batches" :key="batch.id">
                        <v-hover v-slot:default="{ hover }">
                            <div class="batch-box">
                                <div class="batch-details">
                                    <v-tooltip top content-class="cust-new-tooltip-top">
                                        <template v-slot:activator="{ on }">
                                            <h3 v-on="on">{{batch.name}}</h3>
                                        </template>
                                        <span>{{batch.name}}</span>
                                    </v-tooltip>
                                    <p>{{`${batch.total_student} Students`}}</p>
                                </div>
                                <div class="batch-action">
                                    <v-tooltip top content-class="cust-new-tooltip-top">
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-on="on"
                                                text
                                                icon
                                                class="batch-btn"
                                                :class="hover&&batch.total_student<1?'show-cursor':'hide-cursor'"
                                                @click="onDeleteBatch(batch)"
                                            >
                                                <v-icon
                                                    :color="hover&&batch.total_student<1?'red':'#848484'"
                                                >mdi-delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Delete Batch</span>
                                    </v-tooltip>
                                    <v-tooltip top content-class="cust-new-tooltip-top">
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-on="on"
                                                text
                                                icon
                                                class="batch-btn sm-file"
                                                @click="editDuplicateBatch(batch)"
                                            >
                                                <v-icon
                                                    :color="hover?'blue':'#848484'"
                                                >mdi-file-multiple</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Duplicate Batch</span>
                                    </v-tooltip>
                                    <v-tooltip top content-class="cust-new-tooltip-top">
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-on="on"
                                                text
                                                icon
                                                class="batch-btn sm-file"
                                                @click="editBatchDialog(batch)"
                                            >
                                                <v-icon
                                                    :color="hover?'#67d38b':'#848484'"
                                                >mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit Batch</span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </v-hover>
                    </div>

                    <AlertBox
                        :width="modalwidth"
                        :onClose="onClose"
                        :component="cComponent"
                        :status="status"
                        :data="alertData"
                    />
                </div>
                <!-- add v-intersert attribute at the end of div which is outside for loop -->
                <div v-if="selectedCenter && selectedCenter.id" v-intersect="infiniteScrolling"></div>
            </div>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import isMobile from "is-mobile";

export default {
    name: "ManageBatches",
    mounted() {
        // this.setCustomData();
        this.requestGetCenters(false);
        this.initFunction();
    },
    beforeDestroy() {
        window.removeEventListener("resize", null);
    },
    data() {
        return {
            isMobileDevice: isMobile(),
            tableHeight: "350px",
            modalwidth: null,
            batches: [],
            centers: [],
            centersForDuplicate: [],
            classes: [],
            selectedCenter: null,
            selectedBatch: null,
            orderBy: {
                field: "name",
                order: "ASC"
            },
            orderByForCenter: {
                field: "name",
                order: "ASC"
            },
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,

            dialog: false,
            cComponent: "components/coordinator/DuplicateBatch",
            status: false,
            canDeleteCenter: false,
            alertData: null,
            allowScroll: false,
            oldSelectedCenter: null,
            clickCount: 0,
            rowCount: null
        };
    },

    methods: {
        ...mapActions({
            getCenters: "centerAndBatchStore/getCentersByUser",
            getBatches: "centerAndBatchStore/getBatches",
            upsertCenter: "centerAndBatchStore/upsertCenter",
            deleteBatch: "centerAndBatchStore/deleteBatch",
            deleteCenter: "centerAndBatchStore/deleteCenter"
        }),
        ...mapMutations("app", ["addBreadCrumbChilde"]),
        compare(a, b) {
            // Use toUpperCase() to ignore character casing
            const batchA = a.name.toUpperCase();
            const batchB = b.name.toUpperCase();

            let comparison = 0;
            if (batchA > batchB) {
                comparison = 1;
            } else if (batchA < batchB) {
                comparison = -1;
            }
            return comparison;
        },
        defaultData(isCenterDeleted) {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);

            if(crd) {
                let selectedCenter = this.centers.find(c => c.id == crd.selectedTab);
                if(selectedCenter) this.selectedCenter = selectedCenter;
            }
            this.$nextTick(() => {
                this.getBatchesByCenterId();
            });

        },
        checkSessionData(isCenterDeleted) {
            let rp = this.$route; // route params
            let crd = this.getCurrentRouteDetails(rp.name);
            
            // if center is deleted set selected center as the one which was selected before delete one
            if(rp.params.resetPage || !crd.routeName || isCenterDeleted) {
                let selectedTab = crd && crd.selectedTab ? crd.selectedTab : this.centers[0].id;
                if(isCenterDeleted) {
                    if ( !this.selectedCenter && this.centers && this.centers.length ) {
                        if (this.oldSelectedCenter) {
                            this.selectedCenter = this.oldSelectedCenter;
                            this.oldSelectedCenter = null;
                            selectedTab = this.selectedCenter.id;
                        } else {
                            this.selectedCenter = this.centers[0];
                        }
                    } else {
                        this.selectedCenter = this.centers[0];
                    }               
                }
                let routeDetails = {
                    routeName: rp.name,
                    selectedTab: selectedTab
                }
                this.setRouteDetails(routeDetails);
            }
            this.defaultData(isCenterDeleted);
        },
        initFunction() {
            this.isMobileDevice = this.checkIfMobile();
            window.addEventListener(
                "resize",
                _.debounce(this.getBatchesByCenterId, 500)
            );
        },
        checkIfMobile() {
            return isMobile();
        },
        setCustomData() {
            if(!this.$refs.centerBox) return;
            let centerBoxHeight = this.$refs.centerBox.clientHeight;
            let height = window.innerHeight;
            height = height - 180 - centerBoxHeight;

            // height = height - 230 - centerBoxHeight;
            // this.tableHeight = height + "px";
            // let pageSize = height / 180;
            // pageSize = parseInt(pageSize);
            // this.pageSize = (pageSize + 1) * 5;

            if (this.isMobileDevice) {
                this.tableHeight = height + "px";
                this.pageSize = 7;
            } else {
                this.tableHeight = height + "px";
                let pageSize = height / 180;
                pageSize = parseInt(pageSize);
                this.pageSize = (pageSize + 1) * 5;
            }
        },
        infiniteScrolling(entries, observer, isIntersecting) {
            // allowScroll after api gets data for 1st page
            if (
                isIntersecting &&
                this.allowScroll &&
                this.currentPage < this.totalPages
            ) {
                this.currentPage++;
                this.requestGetBatch(this.selectedCenter.id);
            }
        },
        requestDeleteCenter() {
            if (this.canDeleteCenter && this.selectedCenter) {
                let reqData = {
                    id: this.selectedCenter.id
                };
                this.$root.showLoader = true;
                this.deleteCenter(reqData)
                    .then(response => {
                        this.$root.showLoader = false;
                        this.selectedCenter = null;
                        this.batches = [];
                        this.$toasted.success(`${response.msg}`, {
                            icon: "check_circle"
                        });
                        this.requestGetCenters(true);
                    })
                    .catch(err => {
                        this.$root.showLoader = false;
                    });
            }
        },
        requestDeleteBatch(batchId) {
            if (batchId) {
                let reqData = {
                    id: batchId
                };
                this.$root.showLoader = true;
                this.deleteBatch(reqData)
                    .then(response => {
                        this.$root.showLoader = false;
                        this.$toasted.success(`${response.msg}`, {
                            icon: "check_circle"
                        });
                        this.batches = [];
                        this.requestGetBatch(this.selectedCenter.id);
                    })
                    .catch(err => {
                        this.$root.showLoader = false;
                    });
            }
        },
        onBlur(center) {
            if (
                center.editableName &&
                center.editableName.trim().length &&
                center.name !== center.editableName
            ) {
                let reqData = {
                    id: center.id,
                    name: center.editableName
                };
                this.$root.showLoader = true;
                this.upsertCenter(reqData)
                    .then(response => {
                        this.$root.showLoader = false;
                        center.name = center.editableName;
                        center.editable = false;
                    })
                    .catch(err => {
                        this.$root.showLoader = false;
                    });
            } else {
                center.editable = false;
            }
        },
        onDblClick(center) {
            center.editableName = center.name;
            center.editable = true;
        },
        onCenterClick(center) {
            this.clickCount++;

            if (this.clickCount === 1) {
                this.clickTimer = setTimeout(() => {
                    this.clickCount = 0;
                    this.batches = [];
                    this.oldSelectedCenter = _.clone(this.selectedCenter);
                    this.selectedCenter = center;
                    let routeName = this.$route.name;
                    this.setRouteDetails({routeName, selectedTab: center.id});
                    this.requestGetBatch(center.id);
                }, 200);
            } else if (this.clickCount === 2) {
                clearTimeout(this.clickTimer);
                this.clickCount = 0;
                this.onDblClick(center);
            }
        },
        onClose(data) {
            this.status = data.status;
            if (data.action === "yes" && data.refId === "deleteCenter") {
                this.requestDeleteCenter();
            } else if (data.action === "yes" && data.refId === "deleteBatch") {
                this.requestDeleteBatch(data.batch.id);
            } else if (data.reloadBatches) {
                this.updateBatch(data);
            }
        },
        updateBatch(data) {
            let subjectIds = data.subjectIds;
            let subjects = data.subjects;
            let selectedSubjects = [];
            subjectIds.map(sub => {
                let subject = subjects.find(s => s.value.subject_id == sub);
                selectedSubjects.push(subject);
            });
            let batch = data.data.batch;
            batch.subject_ids = selectedSubjects.map(
                sub => sub.value.subject_id
            );
            batch.subjects = selectedSubjects.map(sub => sub.text);
            batch.subject_ids = batch.subject_ids.join(",");
            batch.subjects = batch.subjects.join(",");

            if (this.alertData.isDupicate) {
                batch.total_student = 0;
                this.batches.unshift(batch);
            } else {
                let batchToBeEdited = this.batches.find(b => b.id == batch.id);
                batchToBeEdited = batch;
            }
            this.batches.sort(this.compare);
        },
        editBatchDialog(batch) {
            this.cComponent = "components/coordinator/AddBatch";
            this.alertData = {
                refId: "editBatch",
                batch,
                selectedCenter: this.selectedCenter
            };
            this.modalwidth = "390px";
            this.status = true;
            this.$forceUpdate();
        },
        editDuplicateBatch(batch) {
            let newBatch = _.cloneDeep(batch);
            this.cComponent = "components/coordinator/AddBatch";
            this.alertData = {
                isDupicate: true,
                refId: "duplicateBatch",
                batch: newBatch,
                centersForDuplicate: this.centersForDuplicate,
                selectedCenter: this.selectedCenter
            };
            this.modalwidth = "390px";
            this.status = true;
            this.$forceUpdate();
        },
        onDeleteCenter() {
            if (this.canDeleteCenter && this.selectedCenter) {
                this.cComponent = "components/coordinator/ConfirmationDialog";
                this.alertData = {
                    message: "Are you sure you want to delete Center?",
                    refId: "deleteCenter"
                };
                this.modalwidth = "350px";
                this.status = true;
                this.$forceUpdate();
            }
        },
        onDeleteBatch(batch) {
            if (batch.total_student < 1) {
                this.cComponent = "components/coordinator/ConfirmationDialog";
                this.modalwidth = "350px";
                this.alertData = {
                    message: "Are you sure you want to delete Batch?",
                    refId: "deleteBatch",
                    batch
                };
                this.status = true;
                this.$forceUpdate();
            }
        },
        requestGetBatch(centerId) {
            this.canDeleteCenter = false;
            let reqData = {
                orderBy: this.orderBy,
                center_id: [centerId],
                pagination: { page: this.currentPage, pageSize: this.pageSize }
            };
            if(this.batches.length == this.rowCount) return;

            this.$root.showLoader = true;
            if (centerId) {
                this.getBatches(reqData)
                    .then(response => {
                        this.$root.showLoader = false;
                        if (response && response.list && response.list.length) {
                            this.allowScroll = true;
                            let items = response.list.filter(
                                x => x.total_student > 0
                            );
                            if (!items || items.length < 1) {
                                this.canDeleteCenter = true;
                            }
                            this.batches = this.batches.concat(response.list);
                            this.totalPages = response.pagination.pageCount;
                            this.rowCount = response.pagination.rowCount;
                        } else {
                            this.canDeleteCenter = true;
                            // this.batches = [];
                        }
                    })
                    .catch(err => {
                        this.$root.showLoader = false;
                    });
            } else {
                this.batches = [];
            }
        },
        requestGetCenters(isCenterDeleted) {
            this.$root.showLoader = true;
            this.getCenters({ orderBy: this.orderByForCenter })
                .then(response => {
					if(!response.length){
			            this.$toasted.error("You do not have a center assigned to you. Please contact your Institute Admin.");
					}
					this.$root.showLoader = false;
                    this.centers = response.map(x => {
                        x.editable = false;
                        x.editableName = x.name;
                        return x;
                    });
                    this.centersForDuplicate = response.map(x => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        return c;
                    });
                    this.checkSessionData(isCenterDeleted);
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        getBatchesByCenterId() {
            this.isMobileDevice = this.checkIfMobile();
            this.$nextTick(() => {
                this.setCustomData();
                this.requestGetBatch(this.selectedCenter.id);
            });
        },
        onPageChange(e) {
            this.currentPage = e;
            this.requestGetBatch(this.selectedCenter.id);
        }
    },
    watch: {
        selectedCenter(val) {
            if(val) {
                this.addBreadCrumbChilde([
                    {
                        text: val.name,
                        disabled: false
                    }
                ]);
            }
        }
    }
};
</script>